import configs from '@/configs';
import {request_header, request_list} from '@/commons/hpod';

export default {
    getPayOrderList(cb, $http, param, token) {
        request_list('pay_order', cb, $http, param, token)
    },
    getPayOrderDetail(cb, $http, customerId, token) {
        const req = {
            headers: request_header(token)
        };
        $http.get(`${configs.API}/api/pay_order/${customerId}`, req).then(function (res) {
            setTimeout(() => cb(res.data), 100);
        });
    },
    updatePayOrder(cb, $http, {package_ids, otherFee, uid}, token) {
        const header = {
            headers: request_header(token)
        };
        let req = _.cloneDeep({package_ids: package_ids.join(','), otherFee, uid});
        $http.post(`${configs.API}/api/pay_order/${uid}`, req, header).then(function (res) {
            setTimeout(() => cb(res.data), 100);
        });
    }
}
